var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingBars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#312e81",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2)",
    d: "M0 12 V20 H4 V12z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0,
    keyTimes: "0;.2;.5;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(8)",
    d: "M0 12 V20 H4 V12z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.2,
    keyTimes: "0;.2;.5;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(14)",
    d: "M0 12 V20 H4 V12z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.4,
    keyTimes: "0;.2;.5;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(20)",
    d: "M0 12 V20 H4 V12z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.6,
    keyTimes: "0;.2;.5;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(26)",
    d: "M0 12 V20 H4 V12z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.8,
    keyTimes: "0;.2;.5;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBars);
export default __webpack_public_path__ + "static/media/loading-bars.61b3a2f55e8675d061ddd588aa5245de.svg";
export { ForwardRef as ReactComponent };